import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { api } from "../../../app/applicationSlice";
import { RootState, RootThunk } from "../../../app/store";
import * as service from "../../../services/recardDrug";
import { RecardDrugParams } from "../../../services/recardDrug";
interface RecardDrug {
  RecardDrug: [],
  Total: 0,
  Current: 1,
}

const initialState: RecardDrug = {
  RecardDrug: [],
  Total: 0,
  Current: 1,
};

const recardDrugSlice = createSlice({
  name: "recardDrugSlice",
  initialState,
  reducers: {
    setData(state, action) {
      state.RecardDrug = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
  },
});

export const { setData, 
  setTotal,
  setCurrent, } = recardDrugSlice.actions;

export const selectRecardDrugList =  (state: RootState) => state.recardDrug.RecardDrug

export const selectTotal = (state: RootState) => state.recardDrug.Total
  
export const selectCurrent = (state: RootState) => state.recardDrug.Current



export function getRecardDrugList(params: RecardDrugParams): RootThunk {
  return api(service.getRecardDrug(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
      dispatch(setTotal(data.total))
  });
}


export default recardDrugSlice.reducer;
